import { render } from "./RealNameVerificationView.vue?vue&type=template&id=17a33e88&scoped=true"
import script from "./RealNameVerificationView.vue?vue&type=script&lang=js"
export * from "./RealNameVerificationView.vue?vue&type=script&lang=js"

import "./RealNameVerificationView.vue?vue&type=style&index=0&id=17a33e88&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a33e88"]])

export default __exports__